import { Action, Module, Mutation } from 'vuex-module-decorators';
import store, {currentUserModule} from '@/store';
import { MdbsCore } from '@/api/tsclient';
import BaseModule from '@/store/modules/BaseModule';
import Rights = MdbsCore.Rights;

const dataVisualizationClient = new MdbsCore.AkromegalieDataVisualizationClient();

@Module({ namespaced: true, name: 'dataVisualization', store })
export default class DataVisualizationModule extends BaseModule {
    private _chartDataByKey: Record<string, any[]> = {};

    get getChartData() {
        return (key: string): any[] => {
            return this._chartDataByKey[key] || [];
        };
    }

    @Mutation
    private setChartDataByKey(payload: { key: string; data: any[] }) {
        this._chartDataByKey = {
            ...this._chartDataByKey,
            [payload.key]: payload.data,
        };
    }

    @Mutation
    private clearChartDataKey(key: string) {
        this._chartDataByKey = Object.fromEntries(
            Object.entries(this._chartDataByKey).filter(([k]) => k !== key)
        );
    }


    @Mutation
    private clearAllChartData() {
        this._chartDataByKey = {};
    }

    @Action({ rawError: true })
    async loadAll(key: string) {
        try {
            let response: any[] = [];

            await this.execute(async () => {
                const result = currentUserModule.hasRight(Rights.AkromegalieGetVisualizationDataCmd)?
                    await dataVisualizationClient.getVisualizationData(key):await dataVisualizationClient.getMytVisualizationData(key);

                response = Array.isArray(result) ? result : [];
            });

            this.setChartDataByKey({ key, data: response });
        } catch (e) {
            console.error("Error loading data for", key, e);
            this.clearChartDataKey(key);
        }
    }

}
